import { createFileRoute, ErrorComponentProps, redirect } from '@tanstack/react-router';
import { useRouter } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { FullscreenError, LoadingPage } from '@/components/ui';
import { DEFAULT_REDIRECT_URL } from '@/constants';

const ErrorWrapper = ({ error, reset }: ErrorComponentProps) => {
  const router = useRouter();

  const onDismiss = () => {
    reset();
    router.navigate({ to: '/logout' });
  };

  return <FullscreenError error={error} onDismiss={onDismiss} dismissLabel="Retry login" />;
};

const AuthCallbackSearchSchema = z.object({
  code: z.optional(z.string()),
  error: z.optional(z.string()),
  error_description: z.optional(z.string()),
});

export const Route = createFileRoute('/authCallback')({
  validateSearch: zodValidator(AuthCallbackSearchSchema),
  beforeLoad: async ({ context: { auth }, search }) => {
    if (search.error) {
      throw new Error(search.error_description ?? search.error);
    }

    if (auth.isAuthenticated) {
      const redirectUrl = sessionStorage.getItem('redirectUrl');
      sessionStorage.removeItem('redirectUrl');
      throw redirect({ to: redirectUrl ?? DEFAULT_REDIRECT_URL });
    }

    throw redirect({ to: '/login' });
  },
  pendingComponent: LoadingPage,
  errorComponent: ErrorWrapper,
});
